import React, { useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNav } from "../../components/NavContext";
import { useEffect } from "react";

const BroadcastNotification = () => {
  const [title, setTitle] = useState("خريطة اولان");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const DOMAIN = process.env.REACT_APP_DOMAIN;
  const API_URL = process.env.REACT_APP_API_URL;

  const { addLink } = useNav();

  useEffect(() => {
    addLink("اطبائنا", `${DOMAIN}control/doctor-list`);
    addLink("Broadcast", `${DOMAIN}control/admin/broadcast`);
  }, [addLink, DOMAIN]);

  useEffect(() => {
    document.title = "Broadcast Notification";
  }, []);

  const handleSend = async () => {
    if (!body.trim()) return;

    setLoading(true);
    setResult(null);
    setError(null);

    try {
      const response = await axios.get(`${API_URL}sendnotification`, {
        params: { title: title.trim(), body: body.trim() },
        withCredentials: true,
      });
      setResult(response.data);
    } catch (e) {
      setError(e.response?.data?.message || "فشل إرسال الإشعار");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: 600 }}>
      <header className="mb-4 text-center">
        <h1 className="display-6 mb-1">إشعار لجميع المستخدمين</h1>
        <p className="text-muted mb-0">إرسال إشعار إلى جميع الأجهزة المسجلة</p>
      </header>

      <div className="card shadow-sm">
        <div className="card-body">
          <div className="mb-3">
            <label className="form-label fw-bold">العنوان</label>
            <input
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="عنوان الإشعار"
              dir="rtl"
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-bold">النص</label>
            <textarea
              className="form-control"
              rows={5}
              value={body}
              onChange={(e) => setBody(e.target.value)}
              placeholder="اكتب نص الإشعار هنا..."
              dir="rtl"
            />
          </div>

          <button
            className="btn btn-danger w-100"
            onClick={handleSend}
            disabled={loading || !body.trim()}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                جاري الإرسال...
              </>
            ) : (
              'إرسال إلى جميع المستخدمين'
            )}
          </button>
        </div>
      </div>

      {error && (
        <div className="alert alert-danger mt-3" role="alert">
          {error}
        </div>
      )}

      {result && (
        <div className="alert alert-success mt-3">
          <strong>تم الإرسال بنجاح</strong>
          <div className="mt-2 small">
            <span className="me-3">الأجهزة: {result.device_count}</span>
            <span className="me-3 text-success">نجح: {result.sent_count}</span>
            {result.error_count > 0 && (
              <span className="text-danger">فشل: {result.error_count}</span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BroadcastNotification;
